import React from "react";
import P1 from "../IMG/Team-1.jpg";
import P2 from "../IMG/Team-2.jpg";
import P3 from "../IMG/Team-3.jpg";
import P4 from "../IMG/Team-4.jpg";

function OurTeam() {
    return (
        <>
            <div className="container-xxl py-5">
                <div className="container">
                    <div className="text-center ">
                        <h6 className="text-primary text-uppercase">Our Technicians</h6>
                        <h1 className="mb-5">Our Expert Technicians</h1>
                    </div>
                    <div className="row g-4">
                        <div className="col-lg-3 col-md-6 ">
                            <div className="team-item">
                                <div className="position-relative overflow-hidden">
                                    <img className="img-fluid" src={P1} alt="IMG" />
                                    <div className="team-overlay position-absolute start-0 top-0 w-100 h-100">
                                        <a className="btn btn-square mx-1" href="/"><i className="fab fa-facebook-f"></i></a>
                                        <a className="btn btn-square mx-1" href="/"><i className="fab fa-twitter"></i></a>
                                        <a className="btn btn-square mx-1" href="/"><i className="fab fa-instagram"></i></a>
                                    </div>
                                </div>
                                <div className="bg-light text-center p-4">
                                    <h5 className="fw-bold mb-0">Full Name</h5>
                                    <small>Designation</small>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="team-item">
                                <div className="position-relative overflow-hidden">
                                    <img className="img-fluid" src={P2} alt="IMG" />
                                    <div className="team-overlay position-absolute start-0 top-0 w-100 h-100">
                                        <a className="btn btn-square mx-1" href="/"><i className="fab fa-facebook-f"></i></a>
                                        <a className="btn btn-square mx-1" href="/"><i className="fab fa-twitter"></i></a>
                                        <a className="btn btn-square mx-1" href="/"><i className="fab fa-instagram"></i></a>
                                    </div>
                                </div>
                                <div className="bg-light text-center p-4">
                                    <h5 className="fw-bold mb-0">Full Name</h5>
                                    <small>Designation</small>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                            <div className="team-item">
                                <div className="position-relative overflow-hidden">
                                    <img className="img-fluid" src={P3} alt="IMG" />
                                    <div className="team-overlay position-absolute start-0 top-0 w-100 h-100">
                                        <a className="btn btn-square mx-1" href="/"><i className="fab fa-facebook-f"></i></a>
                                        <a className="btn btn-square mx-1" href="/"><i className="fab fa-twitter"></i></a>
                                        <a className="btn btn-square mx-1" href="/"><i className="fab fa-instagram"></i></a>
                                    </div>
                                </div>
                                <div className="bg-light text-center p-4">
                                    <h5 className="fw-bold mb-0">Full Name</h5>
                                    <small>Designation</small>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.7s">
                            <div className="team-item">
                                <div className="position-relative overflow-hidden">
                                    <img className="img-fluid" src={P4} alt="IMG" />
                                    <div className="team-overlay position-absolute start-0 top-0 w-100 h-100">
                                        <a className="btn btn-square mx-1" href="/"><i className="fab fa-facebook-f"></i></a>
                                        <a className="btn btn-square mx-1" href="/"><i className="fab fa-twitter"></i></a>
                                        <a className="btn btn-square mx-1" href="/"><i className="fab fa-instagram"></i></a>
                                    </div>
                                </div>
                                <div className="bg-light text-center p-4">
                                    <h5 className="fw-bold mb-0">Full Name</h5>
                                    <small>Designation</small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row g-4">
                        <div className="col-lg-3 col-md-6 ">
                            <div className="team-item">
                                <div className="position-relative overflow-hidden">
                                    <img className="img-fluid" src={P1} alt="IMG" />
                                    <div className="team-overlay position-absolute start-0 top-0 w-100 h-100">
                                        <a className="btn btn-square mx-1" href="/"><i className="fab fa-facebook-f"></i></a>
                                        <a className="btn btn-square mx-1" href="/"><i className="fab fa-twitter"></i></a>
                                        <a className="btn btn-square mx-1" href="/"><i className="fab fa-instagram"></i></a>
                                    </div>
                                </div>
                                <div className="bg-light text-center p-4">
                                    <h5 className="fw-bold mb-0">Full Name</h5>
                                    <small>Designation</small>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="team-item">
                                <div className="position-relative overflow-hidden">
                                    <img className="img-fluid" src={P2} alt="IMG" />
                                    <div className="team-overlay position-absolute start-0 top-0 w-100 h-100">
                                        <a className="btn btn-square mx-1" href="/"><i className="fab fa-facebook-f"></i></a>
                                        <a className="btn btn-square mx-1" href="/"><i className="fab fa-twitter"></i></a>
                                        <a className="btn btn-square mx-1" href="/"><i className="fab fa-instagram"></i></a>
                                    </div>
                                </div>
                                <div className="bg-light text-center p-4">
                                    <h5 className="fw-bold mb-0">Full Name</h5>
                                    <small>Designation</small>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                            <div className="team-item">
                                <div className="position-relative overflow-hidden">
                                    <img className="img-fluid" src={P3} alt="IMG" />
                                    <div className="team-overlay position-absolute start-0 top-0 w-100 h-100">
                                        <a className="btn btn-square mx-1" href="/"><i className="fab fa-facebook-f"></i></a>
                                        <a className="btn btn-square mx-1" href="/"><i className="fab fa-twitter"></i></a>
                                        <a className="btn btn-square mx-1" href="/"><i className="fab fa-instagram"></i></a>
                                    </div>
                                </div>
                                <div className="bg-light text-center p-4">
                                    <h5 className="fw-bold mb-0">Full Name</h5>
                                    <small>Designation</small>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.7s">
                            <div className="team-item">
                                <div className="position-relative overflow-hidden">
                                    <img className="img-fluid" src={P4} alt="IMG" />
                                    <div className="team-overlay position-absolute start-0 top-0 w-100 h-100">
                                        <a className="btn btn-square mx-1" href="/"><i className="fab fa-facebook-f"></i></a>
                                        <a className="btn btn-square mx-1" href="/"><i className="fab fa-twitter"></i></a>
                                        <a className="btn btn-square mx-1" href="/"><i className="fab fa-instagram"></i></a>
                                    </div>
                                </div>
                                <div className="bg-light text-center p-4">
                                    <h5 className="fw-bold mb-0">Full Name</h5>
                                    <small>Designation</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default OurTeam;